import { Theme } from '@material-ui/core/styles/createTheme';
import { Palette } from '@material-ui/core/styles/createPalette';

export interface IPalette extends Palette {
  surfaceColor: {
    primary: string;
    secondary: string;
    background: string;
    hover: string;
  };
  onSurfaceColor: {
    primary: string;
    secondary: string;
    tertiary: string;
    selected: string;
  };
  inputColor: {
    secondary: string;
  };
  buttonColor: {
    primary: string;
    disabled: string;
  };
  onButtonColor: {
    secondary: string;
    disabled: string;
  };
  context: {
    error_primary: string;
    error_secondary: string;
    variants_1: string;
    variants_2: string;
    variants_3: string;
    variants_4: string;
    variants_5: string;
    variants_6: string;
  };
}

export interface ITheme extends Theme {
  palette: IPalette;
}

export enum COMPONENT_SIZE {
  SMALL = 'sm',
  MEDIUM = 'm',
  LARGE = 'lg',
}

export enum THEME_ENUM {
  DEFAULT = 'default',
  JETCRAFT = 'jetcraft',
}

export interface IThemes {
  [THEME_ENUM.DEFAULT]: Theme;
  [THEME_ENUM.JETCRAFT]?: Theme | null;
}
